import TopMenuComponent from "../common/TopBar";
import { ApiLibraryWrap } from "../style";
import WebhookCreateForm from "../common/WebhookCreate";

interface Props {}

const CreateWebhook: React.FC<Props> = () => {
  return (
    <ApiLibraryWrap>
      {/* TOPBAR */}
      <TopMenuComponent hideFilters={true} />

      <WebhookCreateForm />
    </ApiLibraryWrap>
  );
};

export default CreateWebhook;
